<template>
  <div
    class="dot"
  >
    {{ nameBadge }}
  </div>
</template>
<script>

import {ref} from "@vue/composition-api";

export default {
  name: 'NameDot',
  components:{

  },
  props: {
    firstName: {
      type: String,
      default: 'N'
    },
    lastName: {
      type: String,
      default: 'N'
    }
  },
  setup(props, context) {
    const nameBadge = ref('')
    nameBadge.value = `${props.firstName.charAt(0)}${props.lastName.charAt(0)}`
    const maybeFullName = props.firstName.split(' ')
    if(props.lastName === '' && maybeFullName.length > 1){
      nameBadge.value = `${maybeFullName[0].charAt(0)}${maybeFullName[1].charAt(0)}`
    }
    return {nameBadge}
  }
}
</script>
<style scoped>
.dot{
  border-radius: 100%;
  background: #535353;
  font-size: 12px;
  font-weight: 600;
  width: 32px;
  height: 32px;
  margin-right: 12px;
  line-height: 32px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/NameDot.vue